import React, { useState } from 'react';
import { Close } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { Dialog, DialogContent, FormControl, InputAdornment, OutlinedInput, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";


const useStyles = makeStyles(theme => ({
    paper:{
     marginBottom:"15px"
    },
    featuredImageTabs: {
      backgroundColor: "#ffffff",
      maxWidth:"800px",
      minWidth:"600px",
      zIndex: "5",
      boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.25)",
      borderRadius: "6px",
      overflowY: "hidden",
      padding: 0,
    },
    featuredImageTabsHeading: {
      fontSize: "22px",
      color: "#434D56",
      padding: "0 15px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    userNote: {
      fontSize: "14px",
      fontWeight: "500",
      color: "#eb5757",
      position: "absolute",
      bottom: "70px",
      zIndex: 999,
      left: "20px",
    },
    fieldsOption: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      marginTop: "4px",
    },
    gridHeaderInner: {
        color: "#000",
        fontSize: "14px",
        fontWeight: "700",
        paddingTop: "14px",
        textAlign:"center",
        backgroundColor: "#E5F2FF",
    },
    gridBodyInner: {
        color: "#464E5F",
        fontSize: "14px",
        fontWeight: "400",
        padding: "15px",
        textAlign:"center"
    },
    tabelCoantner:{
      maxHeight:"500px",
    },
    emailInput: {
      margin:"15px",
      width: "95%",
      '& .MuiInputBase-input': {
          border: "unset !important"
      }
  },
  }));

const MarketingGridModal = ({
    open,
    setOpen,
    data,
}) => {
    const classes = useStyles();
    const [searchTerm, setSearchTerm] = useState('');
    const filteredData = data?.data?.filter(item => 
        item.fullName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.email.toLowerCase().includes(searchTerm.toLowerCase())
    ) || [];

  return (
    <Dialog open={open} onClose={()=>setOpen(null)}>
    <DialogContent className={classes.featuredImageTabs}>
      <h2 className={classes.featuredImageTabsHeading}>
        {data?.title}
        <Close
          style={{
            cursor: "pointer",
          }}
          className={classes.closeTabs}
          onClick={() => setOpen(null)}
        />
      </h2>

        <FormControl className={classes.emailInput} variant="outlined">
          <OutlinedInput
            id="outlined-adornment-weight"
            aria-describedby="outlined-weight-helper-text"
            placeholder='Search'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </FormControl>
      <Paper className={classes.paper}>
      <TableContainer className={classes.tabelCoantner}>
            <Table stickyHeader aria-label="sticky table">
            <TableHead className={classes.gridHeader}>
                <TableRow className={classes.gridHeaderRow}>
                <TableCell className={classes.gridHeaderInner}>
                    Name
                </TableCell>
                <TableCell className={classes.gridHeaderInner}>
                    Email
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData?.length > 0 &&
                filteredData?.map((item, index) => {
                    return (
                        <TableRow key={index} className='gridBodyRow'>
                            <TableCell className={classes.gridBodyInner}>
                                {item.fullName}
                            </TableCell>
                            <TableCell className={classes.gridBodyInner}>
                            {item?.email}
                            </TableCell>
                        </TableRow>
                    )})} 
                    {!filteredData?.length ? (
                      <TableRow key='0' className='gridBodyRow'>
                          <TableCell
                              colSpan='6'
                              className={classes.gridBodyInner}
                              style={{ textAlign: "center" }}>
                              <span className='emptyGridText'>
                                  Uh Oh! No {data?.title} Found.
                              </span>
                          </TableCell>
                      </TableRow>
                  ) : null} 
                </TableBody>
            </Table>
        </TableContainer>
        </Paper>
    </DialogContent>
  </Dialog>
  )
}

export default MarketingGridModal;